export const animationKeyFrames = [
  [
    { offset: 0, textShadow: '0 0 0em rgba(0, 0, 0, 0)' },
    {
      offset: 0.5,
      color: 'rgba(0, 0, 0, 0.5)',
      textShadow: '0 0 0.3em rgba(0, 0, 0, 0)',
    },
    {
      offset: 1,
      color: 'rgba(0, 0, 0, 0)',
      textShadow: '0 0 0.3em rgb(0 0 0)',
    },
  ],
  [
    { offset: 0, textShadow: '0 0 0em rgba(0, 0, 0, 0)' },
    {
      offset: 0.5,
      color: 'rgba(0, 0, 0, 0.5)',
      textShadow: '0 0 0.3em rgba(0, 0, 0, 0)',
    },
    {
      offset: 1,
      color: 'rgba(0, 0, 0, 0)',
      textShadow: '0 0 0.3em rgb(0 0 0)',
    },
  ],
  [
    { offset: 0, color: 'rgba(0, 0, 0, 0)' },
    {
      offset: 0.5,
      color: 'rgba(0, 0, 0, 1)',
      textShadow: '0 0 0em rgba(0, 0, 0, 0)',
    },
    {
      offset: 1,
      color: 'rgba(0, 0, 0, 1)',
      textShadow: '0 0 0em rgb(0 0 0)',
    },
  ],
];
